<template>
	<v-container fluid id="loginCss" fill-height>
		
		<ul class="circles">
	    <li></li>
	    <li></li>
	    <li></li>
	    <li></li>
	    <li></li>
	    <li></li>
	    <li></li>
	    <li></li>
	    <li></li>
	    <li></li>
	  </ul>

	  <v-row justify="center">
	  	<v-col cols="10" sm="6" md="4" lg="3">
				<v-card class="transparent elevation-0">

					<v-card-title primary-title class="text-center">
						<v-spacer></v-spacer>
					  <v-img src="@/assets/fondos/logo_blanco.png" contain max-width="150" v-if="escuela == 1"></v-img>
					  <v-img src="@/assets/fondos/logo_blanco_fast.png" contain max-width="200" v-if="escuela == 2"></v-img>
						<v-spacer></v-spacer>
					</v-card-title>

					<v-card-title primary-title class="text-center">
						<v-spacer></v-spacer>
							<span class="white--text text-h5"> Reenviar correo</span> 
						<v-spacer></v-spacer>
					</v-card-title>

				  <v-form
				    ref="form"
				    v-model="valid"
				    lazy-validation
				  >
				    <v-text-field
				      v-model="matricula"
				      :rules="[rules.required]"
				      label="Matricula"
				      required
				      rounded
				      filled
				      color="primary"
				      class="white mb-4"
				      hide-details
				    ></v-text-field>

				    <v-text-field
				      v-model="correo"
				      :rules="[rules.required]"
				      label="Correo"
				      required
				      rounded
				      filled
				      color="primary"
				      class="white mb-4"
				      hide-details
				    ></v-text-field>
				  </v-form>

				  <v-card-actions>
				    <v-spacer></v-spacer>
				    <v-btn
				      color="white"
				      class="primary--text text-capitalize px-6"
				      @click="reenviarCorreo()"
				      rounded
				      :disabled="disabled"
				      :loading="disabled"
				      @keyup.enter="reenviarCorreo()"
				    >
				      Reenviar correo
				    </v-btn>
				  </v-card-actions>
				</v-card>
	  	</v-col>
	  </v-row>

	  <v-speed-dial
      top
      left
      absolute
    >
      <template v-slot:activator>
        <v-btn
          color="white"
          fab
          :to="{name: 'Login'}"
        >
          <v-icon color="primary">
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
      </template>
    </v-speed-dial>

	  <Alerta    v-if="respuestaAlerta" :parametros="parametros"/>
	  <Loader    v-if="cargar"          :loader="loader"/>

	</v-container>
</template>

<script>
	import { mapActions } from 'vuex'
	// Dependencias
  const md5     = require('md5')

  // Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'

  // Mixins
  import  validarErrores from '@/mixins/validarErrores.js';

  export default {
  	components:{
  		Alerta,
  		Loader
  	},

  	mixins:[validarErrores],

    data: () => ({
    	escuela: null,

      valid: true,
    	
    	// Datos del usuario
    	matricula:'',
    	correo:'',

      showPassword: false,
      rules: {
        required: value => !!value || 'Requerido.'
      },

      respuestaAlerta: false,

      loader: true,
      cargar: false,
			parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},

     	disabled:false
    }),

    created ( ){
    	this.escuela = this.$store.state.ESCUELA 
    },

    methods: {
    	...mapActions( 'login', [ 'grabarUsuario' ]),

      validarDatos () {
        return this.$refs.form.validate()
      },

      reenviarCorreo (){
      	if( this.validarDatos() ){
      		this.cargar = true
      		this.disabled = true
      		// validar los datos del usuario
      		const payload = {
	      		matricula: this.matricula,
	      		correo:    this.correo
	      	}

	      	this.$http.post('usuario.reenviar.correo', payload).then( response => {
	      		this.cargar                    = false
	      		this.disabled                  = false
	      		this.parametros.mensaje        = response.body.message
      			this.parametros.dialogError    = true 
      			this.parametros.color          = 'success'
      			this.$refs.form.reset()
      			this.respuestaAlerta           = true  
	      	}).catch( error => {
	      		this.cargar                    = false
	      		this.disabled                  = false
	      		if( error.status == 400 || error.status == 500 ){
	      			this.parametros.mensaje      = error.body.message
	      			this.parametros.dialogError  = true 
	      			this.parametros.color        = '#FF2C2C' 
	      			this.respuestaAlerta         = true 
	      		}
	      	}).finally( () => { this.cargar = false })
      	}
      },

      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>
